import { call, put, select } from 'redux-saga/effects';
import { first, isEmpty, last, some } from 'lodash';

import LiveDepartureActions from '../../redux/LiveDeparture';
import { getMovements as getCurrentMovements, getStaticStopsInfo } from '../../selectors/DepartureBoardSelectors';
import {
  getMovements,
  getMoreMovements,
  getFilteredRoutes,
  setFilteredRoutes,
} from '../../services/LiveDepartureService';

export function* getFilteredRoutesNames({ stopCode }) {
  let filteredRoutesNames = yield call(getFilteredRoutes, stopCode);
  if (!filteredRoutesNames) {
    filteredRoutesNames = [];
  }
  yield put(LiveDepartureActions.updateFilteredRoutesNames(filteredRoutesNames));
}

export function* storeFilteredRoutesNames({ filteredRoutesNames, stopCode }) {
  yield call(setFilteredRoutes, filteredRoutesNames, stopCode);
  yield put(LiveDepartureActions.updateFilteredRoutesNames(filteredRoutesNames));
}

export function* getDepartures({ shouldRequest, stopCode, options }) {
  if (shouldRequest) {
    try {
      const staticStopsInfoOld = yield select(getStaticStopsInfo);

      // If there are no options, then we're refreshing existing data
      // In order for filter to correct movements,
      //  then use the current movements to define the time range
      const currentMovements = yield select(getCurrentMovements);
      const dateOptions = options ?? (currentMovements ? {
        startDate: first(currentMovements)?.departure_timestamp,
        endDate: last(currentMovements)?.departure_timestamp,
      } : null);

      const { movements, staticStopsInfo, messages } = yield call(getMovements,
        staticStopsInfoOld, stopCode, dateOptions);

      if (isEmpty(staticStopsInfoOld)) {
        yield put(LiveDepartureActions.updateStaticStopsInfo(staticStopsInfo));
      }
      yield put(LiveDepartureActions.updateDepartures(movements, messages, null));
    } catch (error) {
      yield put(LiveDepartureActions.updateStaticStopsInfo(null));
      yield put(LiveDepartureActions.updateDepartures(null, null, error));
    }
  } else {
    yield put(LiveDepartureActions.updateStaticStopsInfo(null));
    yield put(LiveDepartureActions.updateDepartures(null, null, null));
  }
}

export function* getMoreDepartures({ stopCode, options }) {
  try {
    const { movements, staticStopsInfo } = yield call(getMoreMovements, stopCode, options);
    const staticStopsInfoOld = yield select(getStaticStopsInfo);
    yield put(LiveDepartureActions.updateStaticStopsInfo(staticStopsInfoOld.concat(staticStopsInfo.filter(({ keyRouteDepartureTime }) => !some(staticStopsInfoOld, ['keyRouteDepartureTime', keyRouteDepartureTime])))));
    yield put(LiveDepartureActions.appendDepartures(movements));
  } catch (error) {
    yield put(LiveDepartureActions.appendDepartures([]));
  }
}
